import { toastNotificationStore } from '../stores';
import uuid from 'react-uuid';
import { IToastNotification } from '../interfaces/toast-notification';

class NotificationService {

  show = (text: string, type: 'info' | 'warning' | 'error' = 'info') => {
    const notification: IToastNotification = { text, type, id: uuid(), hidden: false };
    toastNotificationStore.addNotification(notification);
    setTimeout(() => {
      notification.hidden = true;
      toastNotificationStore.updateNotification(notification);

      setTimeout(() => {
        toastNotificationStore.removeNotification(notification);
      }, 500);
    }, 2000);
  }

}

export const notificationService = new NotificationService();
